import userReducer, { userActions } from './user.slice';

export { userActions };

export default userReducer;
